import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { getItemCategories } from "../../ItemsCategories/itemCategoriesApi";
import { useState, useEffect } from "react";
import { ItemGETApi } from "../../../utils/utils";
import { Card, Grid, Typography } from "@mui/material";
import ScrollableCategoryTabs from "./popDrop";

export default function SelectItemsCard({ selectedItem, setSelectedItem, handleClose  }) {
  const [value, setValue] = useState(0);
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };




  useEffect(() => {
    const fetchCategories = async () => {
      const payload = {
        page: 1,
        pageSize: 20,
        filterByColumn: "string",
        filterValue: "string",
        searchByColumn: "string",
        searchValue: "string",
        orderByColumn: "string",
        orderBy: "string",
      };

      try {
        const catRes = await getItemCategories(payload);
        if (catRes?.data?.data) {
          setCategories(catRes.data.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchItems = async () => {
      const selectedCategoryId = value === 0 ? null : categories[value - 1]?.id;

      const payload = {
        myBusinessId: 1,
        isCounterSalesItem: true,
        itemCategoryId: selectedCategoryId,
        page: 1,
        pageSize: 200,
        filterByColumn: "string",
        filterValue: "string",
        searchByColumn: "string",
        searchValue: "string",
        orderByColumn: "string",
        orderBy: "string",
      };

      if (!selectedCategoryId) delete payload.itemCategoryId;

      try {
        const itemsRes = await ItemGETApi(payload);
        if (itemsRes?.data?.data) {
          setItems(itemsRes.data.data);
        }
      } catch (error) {
        console.error("Error fetching items:", error);
      }
    };

    fetchItems();



  }, [value, categories]);

  useEffect(()=>{
console.log("valuevalue== ",value)
  },[value])

  return (
    <Box sx={{ maxWidth: { xs: 320, sm: 680 } }}>
      {/* <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "#bb4a9b !important",
          },
          "& .Mui-selected": {
            color: "#bb4a9b !important",
          },
        }}
      >
        <Tab label="All" />
        {categories.map((category) => (
          <Tab
            key={category.id}
            label={`${category.categoryName} (${category.size})`}
            sx={{ fontWeight: "900" }}
          />
        ))}
      </Tabs> */}

      <ScrollableCategoryTabs
        value={value}
        setValue={setValue}
        categories={categories}
      />

      <Box>
        <Card sx={{ maxHeight: "300px", overflowY: "auto" }}>
          <Grid container spacing={2} mt={2} px={2}>
            {items.map((item) => (
              <Grid item xs={12} sm={6} key={item.id}>
                <Card
                  onClick={() => {
                    setSelectedItem(item);
                    handleClose();
                  }}
                  sx={{
                    marginBottom: "10px",
                    padding: "20px",
                    boxShadow: 3,
                    cursor: "pointer",
                    textAlign: "center",
                    background: "#EEEEFF",
                  }}
                >
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color={"primary"}
                    sx={{
                      // textAlign: "center",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    {item.itemDescription}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Card>
      </Box>
    </Box>
  );
}
